// extracted by mini-css-extract-plugin
export default {"label":"PasswordCheckbox_label__Qluxp"};